import styled from "styled-components";

export const Wrap = styled.div`
  display: inline-block;
`;

export const ActiveRoute=styled.h1`
margin:2px 0px;
`
